module.exports = __webpack_public_path__ + "media/components/shared/static/instagram-d66f7340703361cffa71118a58aff7cc.svg";